define('lq/windowSize',[
    'jquery',
    'lq/eventSource'
], function ($, EventSource) {
    'use strict';

    /*
     *
     * IE fires resize event when any elements on the page is resized.
     * This can be triggered by changes in height, styling, etc.
     *
     *
     */

    var $window = $(window);
    
    var WindowSize = function () {
        EventSource.call(this, ['Changed']);

        this.lastWidth = $window.width();
        this.lastHeight = $window.height();

        $window.on('resize', this.resize.bind(this));
    };

    WindowSize.prototype.resize = function() {
        var newWidth = $window.width();
        var newHeight = $window.height();

        if (newWidth === this.lastWidth && newHeight === this.lastHeight)
            return;

        this.lastWidth = newWidth;
        this.lastHeight = newHeight;

        this.triggerChanged();
    };
    
    return new WindowSize();
});
